import { render, staticRenderFns } from "./StickyTemplates.vue?vue&type=template&id=0620966c"
import script from "./StickyTemplates.vue?vue&type=script&lang=js"
export * from "./StickyTemplates.vue?vue&type=script&lang=js"
import style0 from "./StickyTemplates.vue?vue&type=style&index=0&id=0620966c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports